<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-h7`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 5a1 1 0 011 1v16h17V6a1 1 0 011-1h2a1 1 0 011 1v36a1 1 0 01-1 1h-2a1 1 0 01-1-1V26H6v16a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1h2zm39.623 12.338a1 1 0 011 1v1.873l-.04.216-8.57 21.937a1 1 0 01-.931.636h-1.906a1 1 0 01-.929-1.371l8.23-20.571H31.053a1 1 0 01-1-1v-1.72a1 1 0 011-1h13.57z"/></svg>
</template>
<script>

export default {
  name: 'IconH7',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
